import tripService from '../../services/trip/tripService';
import { ReceiptActions } from '../../types/receipt.store.type';
import { Receipt } from 'guest-data-types-ts-lib';
import { fetchTripError } from './trip.actions';

export const fetchReceipt = (reservationId: string) => async (dispatch: any) => {
    try {
        dispatch(fetchReceiptBegin());
        const receipt = await tripService.getReceipt(reservationId);
        dispatch(fetchReceiptSuccess(receipt));
    } catch (e) {
        if (e.status === 403 && isThirdPartyError(e.message)) {
            dispatch(fetchReceiptError(e));
        } else {
            dispatch(fetchTripError(e));
        }
    }
};

export function fetchReceiptBegin() {
    return { type: ReceiptActions.RECEIPT_FETCH_BEGIN };
}

export function fetchReceiptSuccess(receipt: Receipt) {
    return { type: ReceiptActions.RECEIPT_FETCH_SUCCESS, payload: receipt };
}

export function fetchReceiptError(error: Error) {
    return { type: ReceiptActions.RECEIPT_FETCH_ERROR, payload: error };
}

function isThirdPartyError(message: string): boolean {
    return message.includes('THIRD_PARTY_CHANNEL_BOOKING');
}
